import React from "react";

interface CardProps extends React.HTMLAttributes<HTMLElement> {
  isReverse?: boolean;
  showSkeleton?: boolean;
}

const Card: React.FC<CardProps> = ({
  isReverse,
  showSkeleton = false,
  children,
  ...rest
}) => {
  return (
    <>
      <div className="plush-card" {...rest}>
        <div style={{ display: showSkeleton ? "none" : "block" }}>
          {children}
        </div>
        <div
          className={`card-skeleton ${isReverse ? "reverse" : ""}`}
          style={{ display: !showSkeleton ? "none" : "flex" }}
        >
          <div className="rectangle"></div>
          <div className="lines">
            <div className="line-1"></div>
            <div className="line-2"></div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .plush-card {
          width: 394px;
          height: 100px;
          max-width: 100%;

          @media (max-width: 768px) {
            width: 327px;
            height: 74px;
          }

          .card-image {
            width: 100%;
            height: 100%;
          }

          .card-skeleton {
            width: 100%;
            height: 100%;
            background-color: #f8f8f8;
            display: flex;
            padding: 10px 24px;
            justify-content: space-between;

            &.reverse {
              flex-direction: row-reverse;
            }

            .rectangle {
              width: 80px;
              height: 80px;
              background-color: #f1f1f1;
              flex-shrink: 0;

              @media (max-width: 768px) {
                width: 54px;
                height: 54px;
              }
            }

            .lines {
              width: 238px;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;

              @media (max-width: 768px) {
                width: 190px;
              }

              .line-1 {
                width: 167px;
                height: 8px;
                background-color: #f1f1f1;
                margin-bottom: 8px;
              }
              .line-2 {
                width: 238px;
                height: 8px;
                background-color: #f1f1f1;

                @media (max-width: 768px) {
                  width: 190px;
                }
              }
            }
          }
        }
      `}</style>
    </>
  );
};

export default Card;
